/** Normalize gender for caregiver/customer forms and DB. Canonical: male | female | other */
export function normalizeGender(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";
  if (raw === "m" || raw === "male") return "male";
  if (raw === "f" || raw === "female") return "female";
  if (
    raw === "o" ||
    raw === "other" ||
    raw.includes("prefer not") ||
    raw === "non-binary" ||
    raw === "nonbinary"
  ) {
    return "other";
  }
  return "";
}

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];
